import { StateToTypeMap } from 'reducers/FormReducer/FormReducer'
import { ContentBlockFormReducerState } from './RetailerContentBlockReducer'

export enum BlockTypes {
  CONTENT_BLOCKS = 'content_blocks',
  BRAND_LANGUAGE = 'brand_language',
}

// TODO: Units for these functions
export const shiftContentBlockItem = (currentValues: ContentBlockFormReducerState[], idx: number) => {
  const values = Array.from(currentValues)
  const splicedEntry = values.splice(idx, 1)
  values.splice(idx + 1, 0, splicedEntry[0])
  return values
}

export const addNewBlockItem = <T extends keyof StateToTypeMap>(
  currentValues: StateToTypeMap[T][],
  newBlockItem: StateToTypeMap[T],
) => {
  return [...currentValues, newBlockItem]
}

export const removeBlockItem = <T extends keyof StateToTypeMap>(currentValues: StateToTypeMap[T][], idx: number) => {
  const values = Array.from(currentValues)
  values.splice(idx, 1)
  return values
}
